/**
 * Axios Configuration & API Service
 *
 * Central export for all API-related utilities
 *
 * Usage:
 * import apiService, { APIErrorHandler } from '@/lib/axios';
 * import { menuService } from '@/lib/services';
 */

export { default as axiosInstance } from "./axiosInstance";
export { default as apiService } from "./apiService";
export { default as APIErrorHandler, ERROR_MESSAGES } from "./errorHandler";

export type { APIError } from "./errorHandler";
export type { APIResponse } from "./apiService";

// Re-export axios types for convenience
export type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
